import type { ReactNode } from 'react';

import Button, { type ButtonVariant } from '@/components/Button/Button';
import Modal from '@/components/Modal/Modal';

export interface ConfirmModalProps {
  open: boolean;
  title: ReactNode;
  body?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  /** Nested modals (opened over another modal) should not push their own history entry. */
  manageHistory?: boolean;
}

export default function ConfirmModal({
  open,
  title,
  body,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false,
  loading = false,
  onConfirm,
  onCancel,
  manageHistory = false,
}: ConfirmModalProps) {
  const confirmVariant: ButtonVariant = destructive ? 'destructive' : 'primary';

  return (
    <Modal
      open={open}
      onClose={loading ? () => {} : onCancel}
      title={title}
      size="sm"
      manageHistory={manageHistory}
      footer={
        <div className="flex justify-end gap-2">
          <Button type="button" variant="ghost" size="sm" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button type="button" variant={confirmVariant} size="sm" onClick={onConfirm} loading={loading} autoFocus>
            {confirmLabel}
          </Button>
        </div>
      }
    >
      {body && <div className="text-sm text-(--text-secondary)">{body}</div>}
    </Modal>
  );
}
